import * as React            from "react";
import {cs}                  from "@Common/react/chain-services";

export const norcal_market_update = ({specificationFields, specFieldOnChange, next}) => cs(

    // This will make all original spec fields hidden. They will hold the values, & pass those to save function, but not be displayed.
    // Fields 06 & 07 will be displayed as normal fields.
    (({}, next) => next(specificationFields.forEach(field => {
        if (field.fieldKey === "field_66") {
            field.ordinal = 0;
            field.idDisplayStyle = 1;
            field.maxLength = 11;
            field.displayLabel = "Enter Date (mm/dd/yyyy): ";
            if( field.data == field.defaultValue)
            {
                field.data= null;
            }

        } else if (field.fieldKey === "field_65") {
            field.ordinal = 1;
            field.idDisplayStyle = 1;
            field.maxLength = 15;
            field.displayLabel = " Back Headline: ";
            if( field.data == field.defaultValue)
            {
                field.data= null;
            }    

        } else {
            field.idDisplayStyle = 6
        }
    }))),
    ["specFieldDuplicates", ({}, next) => next(specificationFields)],
    ["precedingTextBlocks", ({}, next) => next({
        "field_66":
            "The field below is required.  Please enter a complete date. ",        

        "field_65":
            "Headline: ",

    })],
    // tableFields will be used to display the fields in a 3 column configuration
    ["tableFields", ({specFieldDuplicates}, next) => next([
        {
            ordinal: 0,
            idPrimary: null,
            fieldKey: "3-column-label-field",
            data: null,
            idDisplayStyle: 24,
            visible: true,
            displayLabel: "Property Address",
            columnOneField: "Property Address",
            columnTwoField: "BR/BA",
            columnThreeField: "Price",
            ignoreSave: true,
        },
        ...Array.from({ length: 11 }, (_, i=0) => ({
            ordinal: i + 1,
            idPrimary: null,
            fieldKey: `3-column-field_${String(i + 1).padStart(2, '0')}`,
            data: null,
            idDisplayStyle: 25,
            visible: true,
            columnOneField: `field_${11 + i * 3}`,
            columnTwoField: `field_${12 + i * 3}`,
            columnThreeField: `field_${13 + i * 3}`,
            ignoreSave: true,
            columnOneMaxLength: specFieldDuplicates.find(f => f.fieldKey === `field_${11 + i * 3}`)?.maxLength || 36,
            columnTwoMaxLength: specFieldDuplicates.find(f => f.fieldKey === `field_${12 + i * 3}`)?.maxLength || 8,
            columnThreeMaxLength: specFieldDuplicates.find(f => f.fieldKey === `field_${13 + i * 3}`)?.maxLength || 11,
        })),
    ])],
    (({tableFields, specFieldDuplicates}, next) => next(tableFields.forEach(field => {
        specFieldDuplicates.push(field);
    }))),
    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),


    ({specFieldDuplicates}) => next(specFieldDuplicates)
);